export default __webpack_public_path__ + "static/media/2.1d69f4af.jpg";